module.exports = {
      id: "ic-input-number-plus-usage",
      viewBox: "0 0 8 8",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#ic-input-number-plus-usage",
      toString: function () {
        return this.url;
      }
    }